import * as React from 'react';
import { translate } from 'react-i18next';
import { FollowButton, ItemCardList, LikeButton, WhiteButton } from 'components';
import { ErrorPage } from 'containers';
import { IOutfitCardData, IOutfitCardDataAction } from '../../../models/outfit/outfitcard';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import {
	addOutfitComment,
	resetData,
	getOutfitComments,
	followUser,
	unfollowUser,
	setIsMyProfile,
	getUserFollowButtonData,
	getOutfitCardByCode,
} from 'modules/outfit/outfitcard';
import { IUserCardData } from 'models/user/usercard';
import moment = require('moment');
import { IItemCardList } from '/models/itemcard';
import Slider from 'react-slick';
import { IImageData, IComment, ISelectorItem } from 'models/common';
import { IUserPreferences } from 'models/user/userpreferences';
import { RouteComponentProps, Link } from 'react-router';
import { PortalOneColumnLayout } from 'components/PortalStructure';
import Helmet from 'react-helmet';
import { PinterestShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { AddComment, AuthConsumer } from 'containers';
import { getProductCard } from 'redux/modules/product/productcard';
import { getWardrobeItemCard } from 'redux/modules/wardrobe/wardrobeitemcard';
import { IProductCardDataAction } from 'models/product/productcard';
import { IWardrobeItemCardDataAction } from 'models/wardrobe/wardrobeitemcard';
import { imgSrcAttributes } from 'helpers/common';
const classNames = require('classnames');
const { connect } = require('react-redux');
const { asyncConnect } = require('redux-connect');
require('./style.css');

interface IProps extends RouteComponentProps<IParams, any> {
	outfitCardData?: IOutfitCardData;
	userCardData?: IUserCardData;
	userPreferences: IUserPreferences;
	code?: string;
	baseUrlClient?: string;

	/* function props */
	getOutfitCardByCode?: (code: string, userId: string) => IOutfitCardDataAction;
	addOutfitComment?: (comment: IComment, outfitId: string) => IOutfitCardDataAction;
	getOutfitComments?: (id: string, isFirstLoad?: boolean) => IOutfitCardDataAction;
	followUser?: (id: string) => IOutfitCardDataAction;
	unfollowUser?: (id: string) => IOutfitCardDataAction;
	getUserFollowButtonData?: () => IOutfitCardDataAction;
	setIsMyProfile?: (isMyProfile: boolean) => IOutfitCardDataAction;
	resetData?: () => IOutfitCardDataAction;
	likeOutfit?: () => IOutfitCardDataAction;
	getProductCard: (id: string, target?: string) => IProductCardDataAction;
	getWardrobeItemCard: (id: string, target?: string) => IWardrobeItemCardDataAction;
	t?: (key: string, options?: any) => string;
	dispatch?: any;
}

export const PreviousSlide = (props) => (
	<button onClick={props.onClick} className="left" type="button">
		<img src={require('containers/Html/icons/arrow_left.svg')} />
	</button>
);

export const NextSlide = (props) => (
	<button onClick={props.onClick} className="right" type="button">
		<img src={require('containers/Html/icons/arrow_right.svg')} />
	</button>
);
interface IState {
	socialLinksVisible: boolean;
}
interface IParams {
	code: string;
}

@asyncConnect([
	{
		promise: ({ store: { dispatch, getState }, params, location }) => {
			const outfitCardData = (getState as () => IStore)().outfitCard;
			if (
				(!outfitCardData.outfitCard && params.code && location.query.userId) ||
				(outfitCardData.outfitCard && params.code && params.code !== outfitCardData.outfitCard.code)
			) {
				return Promise.all([dispatch(getOutfitCardByCode(params.code, location.query.userId))]);
			}
		},
	},
])
@connect(
	(state: IStore) => ({
		outfitCardData: state.outfitCard,
		userCardData: state.usercard,
		userPreferences: state.userPreferences,
		baseUrlClient: state.fetchDefault.baseUrlClient,
	}),
	(dispatch) => ({
		dispatch,
		getOutfitCardByCode: (code: string, userId: string) => dispatch(getOutfitCardByCode(code, userId)),
		addOutfitComment: (comment: IComment, outfitId: string) => dispatch(addOutfitComment(comment, outfitId)),
		getOutfitComments: (id: string, isFirstLoad: boolean) => dispatch(getOutfitComments(id, isFirstLoad)),
		followUser: (id: string) => dispatch(followUser(id)),
		unfollowUser: (id: string) => dispatch(unfollowUser(id)),
		getUserFollowButtonData: () => dispatch(getUserFollowButtonData()),
		setIsMyProfile: (isMyProfile: boolean) => dispatch(setIsMyProfile(isMyProfile)),
		getProductCard: (id: string, target?: string) => dispatch(getProductCard(id, target)),
		getWardrobeItemCard: (id: string, target?: string) => dispatch(getWardrobeItemCard(id, target)),
		resetData: () => dispatch(resetData()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OutfitCard extends React.Component<IProps, any, IState> {
	public commentsScrollableDivNode = null;

	constructor(props) {
		super(props);

		this.onAddOutfitComment = this.onAddOutfitComment.bind(this);
		this.followUser = this.followUser.bind(this);
		this.unfollowUser = this.unfollowUser.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.goToCard = this.goToCard.bind(this);

		this.state = {
			socialLinksVisible: false,
		};
	}

	public componentDidMount() {
		this.props.getOutfitCardByCode(this.props.params.code, this.props.location.query.userId);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.userPreferences.id && this.props.userPreferences.id) {
			if (this.props.outfitCardData.outfitCard) {
				const likes = new Likes(LikeNodeType.OutfitCard);
				this.props.dispatch(likes.getLikedItems());
				if (this.props.outfitCardData.outfitCard.userId === this.props.userPreferences.id) {
					this.props.setIsMyProfile(true);
				} else {
					this.props.getUserFollowButtonData();
				}
			}
		}

		if (prevProps.code !== this.props.code) {
			this.props.getOutfitCardByCode(this.props.code, this.props.location.query.userId);
		}

		if (
			(!prevProps.outfitCardData.outfitCard && this.props.outfitCardData.outfitCard) ||
			(prevProps.outfitCardData.outfitCard &&
				this.props.outfitCardData.outfitCard &&
				prevProps.outfitCardData.outfitCard.id !== this.props.outfitCardData.outfitCard.id)
		) {
			this.props.getOutfitComments(this.props.outfitCardData.outfitCard.id, true);
		}
	}

	public componentWillUnmount() {
		this.props.resetData();
	}

	private onAddOutfitComment(comment: IComment) {
		const { id } = this.props.outfitCardData.outfitCard;
		const { name, profilePicture, email } = this.props.userPreferences;
		comment.parentId = id;
		comment.addedBy = name;
		comment.addedByPicture = profilePicture;
		comment.addedByEmail = email;
		this.props.addOutfitComment(comment, id);
	}

	private getImagesContent(): JSX.Element {
		const { outfitCard } = this.props.outfitCardData;

		let content = null;

		if (outfitCard.images && outfitCard.images.length > 0) {
			const settings = {
				customPaging: (i) => {
					return (
						<a>
							<img {...imgSrcAttributes(outfitCard.images[i].href)} />
						</a>
					);
				},
				dots: true,
				dotsClass: 'slick-dots slick-thumb',
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: <PreviousSlide />,
				nextArrow: <NextSlide />,
			};

			content = (
				<Slider {...settings}>
					{outfitCard.images.map((image: IImageData) => {
						return (
							<div key={image.id}>
								<img src={image.href} />
							</div>
						);
					})}
				</Slider>
			);
		} else {
			content = (
				<div>
					<img src={outfitCard.picture} />
				</div>
			);
		}

		return content;
	}

	private likeItem(isAuthenticated, signinRedirect) {
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.OutfitCard);
			this.props.dispatch(likes.likeItem(this.props.outfitCardData.outfitCard.id));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(isAuthenticated, signinRedirect) {
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.OutfitCard);
			this.props.dispatch(likes.unlikeItem(this.props.outfitCardData.outfitCard.id));
		} else {
			signinRedirect();
		}
	}

	private followUser() {
		const userId = this.props.outfitCardData.outfitCard.userId;
		this.props.followUser(userId);
	}

	private unfollowUser() {
		const userId = this.props.outfitCardData.outfitCard.userId;
		this.props.unfollowUser(userId);
	}

	private goToCard(id: string, type: string, target: string) {
		switch (type) {
			case c.NODE_TYPE_WARDROBE:
				this.props.getWardrobeItemCard(id, target);
				break;

			case c.NODE_TYPE_PRODUCT:
				this.props.getProductCard(id, target);
				break;

			default:
				break;
		}
	}

	public render() {
		if (this.props.outfitCardData.error) {
			return <ErrorPage {...this.props} message={this.props.outfitCardData.message} />;
		}

		if (!this.props.outfitCardData.outfitCard) {
			return null;
		}

		const { userPreferences } = this.props;
		const { outfitCard, comments, commentsPage, userIsFollowed, isMyProfile } = this.props.outfitCardData;
		const outfitItems: ISelectorItem[] = JSON.parse(outfitCard.items);

		let userPicture = outfitCard.userPicture;
		if (!userPicture) {
			userPicture = require('containers/Html/images/defaultUser.svg');
		}

		const commentInitialValues: IComment = {
			body: '',
			dataArray: [],
			data: '',
		};

		const outfitItemsListProps: IItemCardList = {
			items: outfitItems,
			itemType: c.NODE_TYPE_OUTFIT_ITEM_SMALL_CARD,
			goToCard: this.goToCard,
		};

		const outfitUrl = this.props.baseUrlClient + '/outfits/' + outfitCard.code + '?userId=' + outfitCard.userId;

		return (
			<AuthConsumer>
				{({ isAuthenticated, signinRedirect }) => {
					return (
						<PortalOneColumnLayout>
							<div className="outfitCardContainer">
								<div className="leftImgComment">{this.getImagesContent()}</div>
								<div className="rightImgComment">
									<div className="dateLike">
										<div className="date">
											<div>{moment.utc(outfitCard.addedDate).fromNow()}</div>
										</div>
										<LikeButton
											isLiked={outfitCard.isLiked}
											likeItem={this.likeItem}
											unlikeItem={this.unlikeItem}
											isAuthenticated={isAuthenticated}
											signinRedirect={signinRedirect}
										/>
									</div>
									<div className="titleWardrobe">{outfitCard.name}</div>
									<div className="descriptionWardrobe">{outfitCard.description}</div>
									<div
										className={classNames('wrapperSocialsPossition', { ['openShare']: this.state.socialLinksVisible })}
									>
										<WhiteButton
											type="button"
											onClick={() => this.setState({ socialLinksVisible: !this.state.socialLinksVisible })}
										>
											Share
										</WhiteButton>
										<div className={classNames('socialIcons', { ['show']: this.state.socialLinksVisible })}>
											<FacebookShareButton url={outfitUrl}>Facebook</FacebookShareButton>
											<TwitterShareButton url={outfitUrl} title={this.props.outfitCardData.outfitCard.name}>
												Twitter
											</TwitterShareButton>
											<PinterestShareButton url={outfitUrl} media={'.'}>
												Pinterest
											</PinterestShareButton>
										</div>
									</div>
									<div className="rightHeadline">Style items</div>
									<div className="row">
										<ItemCardList {...outfitItemsListProps} />
									</div>
									<div ref={(node) => (this.commentsScrollableDivNode = node)}>
										<AddComment
											comments={comments}
											commentsPage={commentsPage}
											onAddComment={(comment: IComment) => {
												this.onAddOutfitComment(comment);
											}}
											initialValues={commentInitialValues}
											loadMoreComments={() => {
												this.props.getOutfitComments(outfitCard.id, false);
											}}
											scrollableDivNode={this.commentsScrollableDivNode}
											userId={userPreferences.id}
										/>
									</div>
								</div>
								<Helmet
									title={outfitCard.metatagTitle || outfitCard.name}
									link={[{ rel: 'canonical', href: outfitUrl }]}
									meta={[
										{ property: 'og:title', content: outfitCard.metatagTitle || outfitCard.name },
										{ property: 'og:image', content: outfitCard.picture },
										{ property: 'og:description', content: outfitCard.metatagDescription || outfitCard.description },
										{ property: 'og:url', content: outfitUrl },
										{ name: 'title', content: outfitCard.metatagTitle || outfitCard.name },
										{ name: 'description', content: outfitCard.metatagDescription || outfitCard.description },
										{ name: 'keywords', content: outfitCard.metatagKeywords },
									]}
								/>
							</div>
							<div className="wrapperBottomUserCard">
								<div className="profileImgWardrobeWrapper">
									<Link to={`/profile/${this.props.outfitCardData.outfitCard.userCode}`}>
										<img {...imgSrcAttributes(userPicture)} />
									</Link>
								</div>
								<div className="profileWardrobeWrapper">
									<div className="positionLocationFollowers">
										{isMyProfile ? null : (
											<FollowButton
												itemType={c.NODE_TYPE_USER}
												displayFollowerCount={true}
												followerCount={outfitCard.userFollowersCount}
												isFollowing={userIsFollowed}
												follow={this.followUser}
												unfollow={this.unfollowUser}
												isMyItem={isMyProfile}
											/>
										)}
									</div>
									<div className="username">{outfitCard.userName}</div>
									<div className="location">{outfitCard.userLocation}</div>
									<div className="description">{outfitCard.userDescription}</div>
								</div>
							</div>
						</PortalOneColumnLayout>
					);
				}}
			</AuthConsumer>
		);
	}
}

export { OutfitCard };
